exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".customer-icon{fill:#1f1f1f}.icon-new-customer_plus{fill:#00003c}", "", {"version":3,"sources":["/divvit-app/client/components/CustomerIcon/client/components/CustomerIcon/style.styl","/divvit-app/client/components/CustomerIcon/style.styl"],"names":[],"mappings":"AAAA,eACE,YAAA,CAEF,wBACE,YAAA,CCCD","file":"style.styl","sourcesContent":[".customer-icon\n  fill: text-light-grey\n\n.icon-new-customer_plus\n  fill: text-blue\n",".customer-icon {\n  fill: #1f1f1f;\n}\n.icon-new-customer_plus {\n  fill: #00003c;\n}\n/*# sourceMappingURL=client/components/CustomerIcon/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/components/CustomerIcon/style.styl
// module id = 608
// module chunks = 0